interface TicketType {
  group_id: string | null;
}

interface Group {
  id: string;
}

export default function groupTicketTypes<T extends TicketType, G extends Group>(
  ticket_types: T[],
  groups: G[]
) {
  return [
    {
      group: null,
      ticket_types: ticket_types.filter((y) => y.group_id == null),
    },
    ...groups
      .map((x) => ({
        group: x,
        ticket_types: ticket_types.filter((y) => x.id == y.group_id),
      }))
      .filter((x) => x.ticket_types.length > 0),
  ];
}
// Extras (a drink card, parking) after every ticket, together under their own heading.
export function withExtrasLast<T extends { kind?: string | null }, G>(
  grouped: { group: G | null; ticket_types: T[] }[],
  extrasGroup: G
) {
  const isExtra = (tt: T) => tt.kind === 'extra';
  return [
    ...grouped.map((g) => ({ ...g, ticket_types: g.ticket_types.filter((tt) => !isExtra(tt)) })),
    { group: extrasGroup, ticket_types: grouped.flatMap((g) => g.ticket_types.filter(isExtra)) },
  ].filter((g) => g.ticket_types.length > 0);
}
